import React, { useEffect, useState } from 'react';
import { onSpecialChangeOnly } from '../../EntityConfigUtils/entityConfigUtils';
import { deleteDeviceService, deviceconfigcrud, getDeviceData, getInterfaceSubTypeData, Getsitelist } from '../../../../services/configurationServices';
import PanelLicense from '../../../Configuration/Site/PanelLicense';
import ConfigurePanelZones from '../../../Configuration/Site/Common/ConfigurePanelZones';
import AssociateCameraOnSensor from '../../../Configuration/Site/Common/AssociateCameraOnSensor'
import { ErrorToast } from '../../../../CustomHooks/ErrorToast';
import { useDeviceType } from '../../../../CustomHooks/useDeviceType';
import { WarningToast } from '../../../../CustomHooks/WarningToast';
import { SuccessToast } from '../../../../CustomHooks/SuccessToast';
import { ConvertDate, ConvertDateToUTC } from '../../../../utils/utils';
import Swal from 'sweetalert2';

let zoneObj = {
    iDSPanelZoneTypeID: 0,
    zoneNo: "",
    zoneName: "",
    idsPanelZonesID: 0,
};

const IDSDeviceForm = ({
    formData = {},
    onFormDataChange,
    errors = {},
    isEditMode = false,
    onCancel,
    interfaceData,
    handleApplyFilters,
    selectedRow
}) => {

    console.log("SelectedRow", selectedRow)

    const [sites, setSites] = useState(null);
    const [interfaceSubTypeData, setInterfaceSubTypeData] = useState([]);
    const [alertsChecked, setAlertChecked] = useState(false);
    const [healthMonitoringChecked, setHealthMonitoringChecked] = useState(false);
    const [selectedDevice, setSelectedDevice] = useState(null);
    const { deviceType, panelDeviceTypeOptions, getDataAfterInterface } = useDeviceType()
    const [selectedZone, setselectedZone] = useState(zoneObj);
    const [selectedSensor, setSelectedSensor] = useState(null);
    const [associatedDevices, setAssociatedDevices] = useState(null);
    const [selectedItems, setSelectedItems] = useState([]);

    useEffect(() => {
        getSites();
    }, [])

    useEffect(() => {
        if (interfaceData != undefined) {
            getInterfaceSubType(interfaceData.InterfaceTypeId);
            getDeviceDataFunc(interfaceData?.InterfaceId)
        }
    }, [interfaceData])

    const getDeviceDataFunc = (id) => {
        try {
            getDeviceData(id).then((resp) => {
                if (resp != undefined) {
                    if (resp.Status == "success") {
                        console.log("ResData", resp.Data[0])
                        if (resp.Data.length > 0) {
                            setSelectedDevice(resp.Data[0]);
                            setAlertChecked(resp.Data[0]?.AlertMonitoring)
                            setHealthMonitoringChecked(resp.Data[0]?.HMMonitoring)
                        }
                    } else {
                        setSelectedDevice(null);
                    }
                }
            });
        } catch (error) {
            console.error(error);
        }
    }

    // useEffect(() => {
    //     if(formData != undefined){
    //         let obj = {
    //             ...formData,
    //             panelMasterId: formData?.DeviceId
    //         }
    //         setSelectedDevice(obj)
    //     }
    // }, [formData])

    const getSites = () => {
        try {
            Getsitelist().then((resp) => {
                if (resp != undefined) {
                    if (resp.Status == "success") {
                        setSites(resp.Data);
                    } else {
                        setSites(null);
                    }
                }
            });
        } catch (error) {
            console.error(error);
        }
    };

    const getInterfaceSubType = (interfaceType) => {
        try {
            let obj = {
                type: "interfacesubtypemaster",
                parameters: {
                    InterfacetypeId: interfaceType,
                },
            };
            if (interfaceType != undefined) {
                getInterfaceSubTypeData(obj).then((resp) => {
                    if (resp != undefined) {
                        if (resp.Status == "success") {
                            setInterfaceSubTypeData(resp.Data);
                        } else {
                            setInterfaceSubTypeData(null);
                        }
                    }
                });
            }
        } catch (error) {
            console.error(error);
        }
    };

    const OnAddIDSPanel = async (data, parentCameraID, action, zoneNo) => {
        try {
            let myCurrentDatetime = new Date();
            let datetime = ConvertDate(myCurrentDatetime);
            let loggedInUser = JSON.parse(localStorage.getItem("user"));
            let userUniqueId = loggedInUser.UserUniqueID || loggedInUser.userUniqueID;
            let devObj = {}
            if (action == "addPanelDevice" || action == "updatePanelDevice") {
                let panelname = "";
                if (data.cameraName) {
                    panelname = data.cameraName.trim();
                }
                if (
                    data.PanelMasterId == 0 ||
                    data.PanelMasterId == undefined ||
                    data.PanelMasterId == ""
                ) {
                    ErrorToast("Select brand name!");
                } else if (
                    panelname == "" ||
                    panelname == undefined ||
                    panelname == ""
                ) {
                    ErrorToast("Enter panel name!");
                } else if (
                    data.privateIPAddress == "" ||
                    data.privateIPAddress == "" ||
                    data.privateIPAddress == undefined
                ) {
                    ErrorToast("Enter IP address!");
                } else if (data.SiteID == 0) {
                    ErrorToast("Select branch name!");
                } else {
                    devObj = {
                        action: action,
                        panelMasterID: data.PanelMasterId,
                        userUniqueId: userUniqueId,
                        privateIp: data.privateIPAddress,
                        panelName: panelname,
                        dateTime: datetime,
                        siteId: data.SiteID,
                        deviceId: parentCameraID,
                        interfaceId: interfaceData.InterfaceId,
                    };
                }
            } else if (action == "addPanelZones") {
                if (
                    data.iDSPanelZoneTypeID == 0 ||
                    data.iDSPanelZoneTypeID == undefined
                ) {
                    ErrorToast("Please select zone type!");
                    return
                } else if (data.ZoneNo < 1 || data.ZoneNo > 256) {
                    ErrorToast(
                        "Please enter a valid zone number! In the range of 1 to 256."
                    );
                    return
                } else if (data.ZoneName == "") {
                    ErrorToast("Please enter a zone name!");
                    return
                } else {
                    devObj = {
                        action: action,
                        userUniqueId: localStorage.getItem('UserID'),
                        dateTime: datetime,
                        iDSPanelZoneTypeID: data.iDSPanelZoneTypeID,
                        zoneName: data.ZoneName,
                        zoneNo: data.ZoneNo,
                        deviceId: data.idsPanelZonesID,
                        parentDeviceId: parentCameraID,
                        SerialNo: data.SerialNo
                    };
                }
            } else if (action == "addPanelZoneTypeMaster") {
                if (data.trim() == "") {
                    ErrorToast("Enter zone type!");
                    return;
                }
                devObj = {
                    action: action,
                    userUniqueId: localStorage.getItem('UserID'),
                    dateTime: datetime,
                    zoneType: data.trim(),
                    interfaceTypeID: interfaceData.InterfacetypeId
                };
            } else if (action == "deletePanel") {
                devObj = null;
                await Swal.fire({
                    title: "Are you sure?",
                    text: "Do you want to delete panel device",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#027aaa",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Yes!",
                    allowOutsideClick: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        devObj = {
                            action: action,
                            deviceId: parentCameraID,
                            userUniqueId: userUniqueId,
                        };
                        let deviceObj = {
                            ParentCameraID: 0,
                            SiteID: 0,
                        };
                        setSelectedDevice(deviceObj);
                    }
                });
            } else if (action == "deleteZone") {
                devObj = null;
                await Swal.fire({
                    title: "Are you sure?",
                    text: "Do you want to delete zone device",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#027aaa",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Yes",
                    allowOutsideClick: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        devObj = {
                            action: action,
                            deviceId: parentCameraID,
                            idsPanelZoneTypeID: data,
                            userUniqueId: userUniqueId,
                            zoneNo: zoneNo,
                        };
                        setselectedZone(zoneObj);
                    }
                });
            } else if (action == "updatePanelZone") {
                if (
                    data.iDSPanelZoneTypeID == 0 ||
                    data.iDSPanelZoneTypeID == undefined
                ) {
                    ErrorToast("Please select zone type!");
                } else if (data.ZoneNo < 1 || data.ZoneNo > 256) {
                    ErrorToast(
                        "Please enter a valid zone number! In the range of 1 to 256."
                    );
                } else if (data.ZoneName == "") {
                    ErrorToast("Please enter a zone name!");
                } else {
                    devObj = {
                        action: action,
                        userUniqueId: localStorage.getItem('UserID'),
                        dateTime: datetime,
                        userID: localStorage.getItem('UserID'),
                        idsPanelZoneTypeID: data.iDSPanelZoneTypeID,
                        zoneName: data.ZoneName,
                        zoneNo: data.ZoneNo,
                        deviceId: data.idsPanelZonesID,
                        idsPanelZonesID: parentCameraID,
                        SerialNo:data.SerialNo
                    };
                }
            }
            if (devObj == null || devObj == undefined) {
                return;
            }
            deviceconfigcrud(devObj).then((resp) => {
                if (resp && (resp.Status === "Ok" || resp.Status === "success")) {
                    if (action == "addPanelDevice") {
                        if (resp && resp.deviceId) {
                            let deviceObj = {
                                ParentCameraID: 0,
                                cameraName: "",
                                privateIPAddress: "",
                                SiteID: 0,
                                userName: "",
                                password: "",
                                port: "",
                                channelNumber: "",
                                liveStreamTypeNumber: "",
                                playbackStreamTypeNumber: "",
                                rTSPURL: "",
                                location: "",
                                PanelMasterId: 0,
                                CameraBrandId: 0,
                                communicationPort: "",
                                httpPort: "",
                                isTranscoded: "",
                                isPlaybackTranscoded: "",
                                isTwoWayEnabledDevice: "",
                                CCTVTypeID: 0,
                                cameraDeviceId: 0
                            };
                            setSelectedDevice(deviceObj);
                        }
                        window.scrollTo({ top: 600, left: 0, behavior: "smooth" });
                    } else {
                        // setIsDeviceEdit(false);
                    }

                    if (action == "addPanelZones") {
                        if (action == "addPanelZones") {
                            let zoneObj = {
                                iDSPanelZoneTypeID: 0,
                                zoneNo: "",
                                zoneName: "",
                                idsPanelZonesID: 0,
                            };
                            setselectedZone(zoneObj);
                            getDeviceDataFunc(interfaceData?.InterfaceId)
                        }
                        else {
                            let updatedObj = {
                                iDSPanelZoneTypeID: data.iDSPanelZoneTypeID,
                                idsPanelZonesID: resp.Data.DeviceId,
                                zoneName: data.ZoneName,
                                zoneNo: data.ZoneNo,
                            };
                            setselectedZone(updatedObj);
                            getDeviceData(interfaceData.InterfaceId)
                                .then((res) => {
                                    if (res.Status == 'success') {
                                        setSelectedDevice(res.Data[0])
                                        SuccessToast('Device updated sucessfully');
                                    }
                                    else {
                                        WarningToast('something went wrong');
                                    }
                                });

                        }


                    }
                    if (action == "updatePanelZone") {
                        let zoneObj = {
                            iDSPanelZoneTypeID: 0,
                            zoneNo: "",
                            zoneName: "",
                            idsPanelZonesID: 0,
                        };
                        setselectedZone(zoneObj);
                        getDeviceData(interfaceData.InterfaceId)
                            .then((res) => {
                                if (res.Status == 'success') {
                                    setSelectedDevice(res.Data[0]);
                                }
                                else {
                                    WarningToast('something went wrong');
                                }
                            });
                    }
                    if (action == "deletePanel") {
                        // setAssociateCamSecVisibility(false);
                    }
                    if (action == "addPanelZoneTypeMaster") {
                        getDataAfterInterface(interfaceData?.InterfacetypeId);
                    }
                    SuccessToast(resp.Message);
                } else {
                    ErrorToast(resp.Message);
                    console.error(resp);
                }
            });
        } catch (error) {
            console.log(error);
        }
    };

    const deleteZone = async (id) => {
        let userId = localStorage.getItem("UserID");
        await Swal.fire({
            title: "Are you sure?",
            text: "Do you want to delete zone device",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#027aaa",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes",
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                // Call API service function over here.
                deleteDeviceService(userId, id)
                    .then((res) => {
                        if (res.Status == "success") {
                            let zoneObj = {
                                iDSPanelZoneTypeID: 0,
                                zoneNo: "",
                                zoneName: "",
                                idsPanelZonesID: 0,
                            };
                            setselectedZone(zoneObj);
                            SuccessToast(res.Message);
                            // Get Devices List.        
                            getDeviceData(interfaceData.InterfaceId)
                                .then((res) => {
                                    if (res.Status == 'success') {
                                        let tempData = res.Data[0];
                                        tempData["ParentCameraID"] = res.Data[0].DeviceId
                                        setSelectedDevice(tempData)
                                    }
                                    else {
                                        WarningToast('something went wrong');
                                    }
                                });
                        }
                    })
            }
        });
    }

    const onSensorSelection = (sensor, devicedt) => {
        try {
            if (sensor) {
                setSelectedSensor(sensor);
                var obj1 = {
                    action: "getAssociatedCamerasList",
                    deviceId: sensor.idsPanelZonesID,
                    idsPanelZoneTypeID: sensor.iDSPanelZoneTypeID,
                    userUniqueId: localStorage.getItem('UserID'),
                    clientId: devicedt.clientId,
                    branchId: devicedt.BranchID,
                    siteId: devicedt.SiteId
                };
                deviceconfigcrud(obj1).then((resps) => {
                    if (resps && resps.status === "Ok" || resps && resps.Status === "success") {
                        setAssociatedDevices(null);

                        if (resps.Data && resps.Data.length > 0) {
                            const selDevList = [];
                            for (let i = 0; i < resps.Data.length; i++) {
                                const device = resps.Data[i];
                                if (device.isSelected == true) {
                                    selDevList.push(device);
                                }
                            }
                            if (selDevList.length > 0) {
                                setSelectedItems(selDevList.map((item) => item.deviceId));
                            } else {
                                setSelectedItems([]);
                            }
                            setAssociatedDevices(resps.Data);
                        } else {
                            setSelectedItems([]);
                        }
                    }
                });
            }
        } catch (error) {
            console.log(error);
        }
    };

    const onAssociate = (selectedDevice) => {
        const maxAssociations = 4;
        if (selectedItems.length > maxAssociations) {
            ErrorToast(
                `Maximum only ${maxAssociations} cameras can be associated, you have associated ${selectedItems.length} cameras`
            );
            return;
        }
        let payload = {
            action: "associateCamerasToSensor",
            associatedCameraIds: selectedItems,
            deviceId: selectedSensor.idsPanelZonesID,
            idsPanelZoneTypeId: selectedSensor.iDSPanelZoneTypeID,
            createdBy: localStorage.getItem("UserID"),
            createdOn: ConvertDateToUTC(new Date()),
            userUniqueId: null,
            isHooterEnabledInterface: selectedDevice.isHooterEnabledInterface,
        };
        deviceconfigcrud(payload)
            .then((resp) => {
            const isSuccess = resp?.Status === "Ok" || resp?.Status === "success"
            if (isSuccess) {
                SuccessToast(resp.Message);
            } else {
                ErrorToast("Error occurred while associating the device!");
            }
        }).catch(() => {
            ErrorToast("Unexpected error occurred while associating the device!");
        });
    };

    return (
        <>
            <div className="site-form">
                <h6 className="form-section-title">IDS Device Configuration</h6>
            </div>
            <div className='DeviceFormScroll' style={{ display: 'flex', flexDirection: 'column' }}>
                <div className="site-form">

                    <div className="inputMainContainer w40dot75rem">
                        <div className="inputTypeLabelContainer">
                            <label className='formFieldLabels'>Brand Name</label>
                            {/* <select
                                className="inputType ArrowSelectClass"
                                placeholder="Select Brand Name"
                                disabled
                                value={interfaceData?.InterfacesubtypeId}
                                onChange={(e) => handleApplyFilters(e.target.value)}
                            >
                                <option key="0" disabled={false} value="">Brand Name*</option>
                                {interfaceSubTypeData &&
                                    interfaceSubTypeData.map((site) => (
                                        <option value={site.InterfacesubtypeId}
                                            key={site.InterfacesubtypeId}
                                            id={site.InterfacesubtypeId}>
                                            {site.Interfacesubtypename}
                                        </option>
                                    ))}
                            </select> */}
                            <input
                                type="text"
                                className="inputType"
                                disabled={true}
                                placeholder="Enter Panel name* e.g. Thane panel"
                                defaultValue={interfaceData?.Interfacesubtypename}
                                onKeyPress={onSpecialChangeOnly}
                            />
                        </div>
                    </div>

                    <div className="inputMainContainer w40dot75rem mt35">
                        <div className="inputTypeLabelContainer">
                            <label className='formFieldLabels'>Panel Name</label>
                            <input
                                type="text"
                                className="inputType"
                                disabled={true}
                                placeholder="Enter Panel name* e.g. Thane panel"
                                defaultValue={selectedRow?.DeviceName}
                                onKeyPress={onSpecialChangeOnly}
                            />
                        </div>
                    </div>

                    <div className="inputMainContainer w40dot75rem mt35">
                        <div className="inputTypeLabelContainer">
                            <label className='formFieldLabels'>IP Address</label>
                            <input
                                className="inputType"
                                disabled={true}
                                placeholder="IP address* e.g. 192.168.0.54"
                                defaultValue={interfaceData?.InterfaceIP}
                            />
                        </div>
                    </div>

                    <div className="inputMainContainer w40dot75rem mt35">
                        <div className="inputTypeLabelContainer">
                            <label className='formFieldLabels'>Zone</label>
                            {/* <select
                                className="inputType ArrowSelectClass"
                                placeholder="Site"
                                disabled={true}
                                defaultValue={interfaceData?.SiteId}
                            >
                                <option key="0" disabled={false} value="0">Branch Name*</option>
                                {sites &&
                                    sites.map((site) => (
                                        <option value={site.SiteID} key={site.SiteID}>
                                            {site.SiteName}
                                        </option>
                                    ))}
                            </select> */}
                            <input
                                type="text"
                                className="inputType"
                                disabled={true}
                                placeholder="Enter Panel name* e.g. Thane panel"
                                defaultValue={selectedRow?.ZoneName}
                                onKeyPress={onSpecialChangeOnly}
                            />
                        </div>
                    </div>

                    <div className="inputMainContainer w40dot75rem mt35">
                        <div className="inputTypeLabelContainer">
                            <label className='formFieldLabels'>Serial No</label>
                            <input
                                type="text"
                                className="inputType"
                                disabled={true}
                                placeholder="Enter Serial No e.g. MH78UY"
                                defaultValue={selectedRow?.SerialNo}
                                onKeyPress={onSpecialChangeOnly}
                            />
                        </div>
                    </div>


                    {
                    <PanelLicense
                        DeviceId={selectedRow?.DeviceId}
                        alertsChecked={alertsChecked}
                        healthMonitoringChecked={healthMonitoringChecked}
                        setHealthMonitoringChecked={setHealthMonitoringChecked}
                        setAlertChecked={setAlertChecked}
                    />
                }
                {
                    <ConfigurePanelZones
                        selectedDevice={selectedDevice}
                        OnAddIDSPanel={OnAddIDSPanel}
                        deleteZone={deleteZone}
                        setselectedZone={setselectedZone}
                        selectedZone={selectedZone}
                        isDeviceEdit={false}
                        selectedInterface={interfaceData}
                        panelDeviceTypeOptions={panelDeviceTypeOptions}
                        getDataAfterInterface={getDataAfterInterface}
                    />
                }
                {
                    <AssociateCameraOnSensor
                        selectedDevice={selectedDevice}
                        onSensorSelection={onSensorSelection}
                        associatedDevices={associatedDevices}
                        onAssociate={onAssociate}
                        selectedSensor={selectedSensor}
                        selectedItems={selectedItems}
                        setSelectedItems={setSelectedItems}
                        isDeviceEdit={false}
                    />
                }

                </div>
                
            </div>


            <div style={{ textAlign: "center", marginTop: "30px" }}>
                {/* <button className="DataAccessEdit" style={{ width: "100px" }}>
                    <span className="ViewUpdate">Save</span>
                </button> */}
                <button className="DataAccessEdit" style={{ width: "100px", marginLeft: "10px" }} onClick={onCancel}>
                    <span className="ViewUpdate">Cancel</span>
                </button>
            </div>
        </>
    );
};

export default IDSDeviceForm;
